export default __webpack_public_path__ + "static/img1-8a4ae0cd2bf5865158228a4c5abcb0bb.webp";